import { useCallback } from 'react'
import {
    subscribeToForm,
    submitFormToFHIR,
    updateForm,
    markFormEnteredInError,
    fetchQuestionnaireByName,
} from 'app/api/forms/repository/formsRepository'
import { FormDto } from 'app/models/generated'
import { AccForm } from 'app/api/forms/dto/accFormDto'

/**
 * React hook for form repository operations.
 * Wraps `subscribeToForm`, `submitFormToFHIR`, `updateForm`,
 * `markFormEnteredInError`, and `fetchQuestionnaireByName` from formsRepository
 * so components import from hooks instead of directly from the repository.
 */
export const useFormRepository = () => {
    const subscribe = useCallback(
        (id: string, callback: (accForm: FormDto) => void) => {
            return subscribeToForm(id, callback)
        },
        []
    )

    const submitToFHIR = useCallback(
        (formId: string, userId: string): Promise<boolean> => {
            return submitFormToFHIR(formId, userId)
        },
        []
    )

    const update = useCallback(
        (formId: string, updatedForm: AccForm): Promise<void> => {
            return updateForm(formId, updatedForm)
        },
        []
    )

    const markEnteredInError = useCallback(
        (formId: string, userId: string): Promise<void> => {
            return markFormEnteredInError(formId, userId)
        },
        []
    )

    const fetchQuestionnaire = useCallback(
        (
            name: string
        ): Promise<{ title: string; publisher: string } | null> => {
            return fetchQuestionnaireByName(name)
        },
        []
    )

    return {
        subscribeToForm: subscribe,
        submitFormToFHIR: submitToFHIR,
        updateForm: update,
        markFormEnteredInError: markEnteredInError,
        fetchQuestionnaireByName: fetchQuestionnaire,
    }
}
